import React from "react";

const MSG = {
  de: ["Ups, da ist etwas schiefgelaufen.", "Seite neu laden"],
  en: ["Oops, something went wrong.", "Reload page"],
  tr: ["Bir şeyler ters gitti.", "Sayfayı yenile"],
  ru: ["Что-то пошло не так.", "Обновить страницу"],
  it: ["Qualcosa è andato storto.", "Ricarica la pagina"],
  es: ["Algo salió mal.", "Recargar página"],
  fr: ["Un problème est survenu.", "Recharger la page"],
  pl: ["Coś poszło nie tak.", "Odśwież stronę"], sr: ["Упс, нешто је пошло наопако.", "Поново учитај страницу"], hr: ["Ups, nešto je pošlo po zlu.", "Osvježi stranicu"], sq: ["Ups, diçka shkoi keq.", "Ringarko faqen"], sl: ["Ups, nekaj je šlo narobe.", "Ponovno naloži stran"], pt: ["Ups, algo correu mal.", "Recarregar página"], cs: ["Jejda, něco se pokazilo.", "Znovu načíst stránku"], hu: ["Hopp, valami hiba történt.", "Oldal újratöltése"], hi: ["ओह, कुछ गड़बड़ हो गई।", "पेज रीलोड करें"], ms: ["Alamak, ada masalah.", "Muat semula halaman"], nl: ["Oeps, er ging iets mis.", "Pagina opnieuw laden"], zh: ["哎呀，出错了。", "刷新页面"]
};

// Last-resort safety net: show a reload card instead of a blank white page.
export class ErrorBoundary extends React.Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("UI crash:", error, info?.componentStack); }
  render() {
    if (!this.state.error) return this.props.children;
    let lang = "de";
    try { lang = (localStorage.getItem("lang") || "de").slice(0, 2); } catch {}
    const [title, btn] = MSG[lang] || MSG.en;
    return (
      <div data-testid="error-boundary" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, fontFamily: "system-ui, sans-serif" }}>
        <div style={{ maxWidth: 380, textAlign: "center" }}>
          <p style={{ fontSize: 18, fontWeight: 700, marginBottom: 16 }}>{title}</p>
          <button type="button" data-testid="error-boundary-reload" onClick={() => window.location.reload()}
            style={{ background: "#22C55E", color: "#fff", border: 0, borderRadius: 12, padding: "10px 20px", fontWeight: 600, cursor: "pointer" }}>
            {btn}
          </button>
        </div>
      </div>
    );
  }
}
